export default (() => ({
  font: {
    headingFontWeight: 'bold',
    headingFontFamily: '"AvenirNextLTPro", sans-serif',
    bodyFontFamily: '"AvenirNextLTPro", sans-serif',
    accentFontFamily: '"AvenirNextLTPro", sans-serif',
    fontSize: '36px',
    fontWeight: 'normal',
    lineHeight: '44px',
    h2FontSize: '28px',
    h2FontWeight: 'normal',
    h2LineHeight: '32px',
    h3FontSize: '22px',
    h3FontWeight: 'normal',
    h3LineHeight: '28px',
    h4FontSize: '18px',
    h4FontWeight: 'normal',
    h4LineHeight: '22px',
    h5FontSize: '13px',
    h5FontWeight: 'normal',
    h5LineHeight: '16px',
    baseFontSize: '16px',
    baseLineHeight: '24px',
    smallFontSize: '14px',
    smallLineHeight: '20px'
  }
}));